import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportSummaryPagedResponse } from 'src/app/core/models/Report/ReportSummaryPagedResponse';


@Injectable({
  providedIn: 'root'
})
export class ReportService {

    constructor(
        private api: ApiService,
        private _http: HttpClient
    ) { }

    /**
     * Permite optener los datos de la empresa en sesión
     */
    getCompanyInfo( filter?: string) {
        return this._http.get<any[]>(this.api.getUrl(`api/Company/Select?${ filter ? filter : ''}`));
    }
    /**
     * Permite obtener los proyectos de la empresa en sesión
     * @param companyInfoId id de la empresa en sesión
     */
    //  &isActive=true
    isActive = null;
    getProjectsFilter( companyInfoId: string, subcontractors) {
        return this._http.get<any>(this.api.getUrl(`api/Project/Filter?companyInfoId=${companyInfoId}${this.isActive === null ? '': '&isActive=true'}${subcontractors !== undefined ? '&subcontractors=' + subcontractors : '' }`));
    }
    /**
     * Permite obtener solo los proyectos (sin Employers, Personals ni Contracts)
     */
    getProjectsSelect(companyInfoId: string, subcontractors?: boolean): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Project/Select?companyInfoId=${companyInfoId}${subcontractors !== undefined ? '&subcontractors=' + subcontractors : ''}`));
    }
    /**
     * Permite obtener solo los empleadores de una empresa (sin Personals ni Contracts)
     */
    getEmployersSelectByCompany(companyInfoId: string, subcontractors?: boolean): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Employer/Select?companyInfoId=${companyInfoId}${subcontractors !== undefined ? '&subcontractors=' + subcontractors : ''}`));
    }
    /**
     * Permite optener los empleadors de cada proyecto
     */
    getCompaniesFilter( filter: string): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Employer/Filter?companyInfoId=${filter}${this.isActive === null ? '': '&isActive=true'}`));
    }
    /**
     * Permite optener los empleadors de cada proyecto
     */
    getCompaniesSelect( filter: string): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Employer/Select?companyInfoId=${filter}${this.isActive === null ? '': '&isActive=true'}`));
    }

    getContractSelect( filter: string): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Contract/Filter?companyInfoId=${filter}${this.isActive === null ? '': '&isActive=true'}`));
    }

    /**
     * Version liviana de Contratos (api/Contract/Select) usada solo por el informe 103,
     * para no depender de api/Project/Filter (union pesada de Projects+Employers+Personals+Contracts).
     */
    getContractsSelect(projectId: string, employerId: string, subcontractors?: boolean): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Contract/Select?projectId=${projectId}&employerId=${employerId}${subcontractors !== undefined ? '&subcontractors=' + subcontractors : ''}`));
    }

    downloadReport( filter: string): Observable<Blob> {
        return this._http.get(this.api.getUrl(`api/ReportJava/${filter}`), {responseType: 'blob' });
    }

    downloadReportV2(filter: string): Observable<Blob>{
        return this._http.get(this.api.getUrl(`api/ReportJavaV2/${filter}`), {responseType: 'blob' });
    }

    summaryRequisitosAcceso(filter: string): Observable<ReportSummaryPagedResponse>{
        return this._http.get<ReportSummaryPagedResponse>(this.api.getUrl(`api/summary/${filter}`));
    }

    graphRequisitosAcceso(filter: string): Observable<ReportSummaryPagedResponse>{
        return this._http.get<ReportSummaryPagedResponse>(this.api.getUrl(`api/graph/${filter}`));
    }

    downloadReportPost(filter: any) {
        return this._http.post(this.api.getUrl(`api/ReportJava/RequirementAccess`), filter);
    }

    getPersonalDocNum(docNum, companyId) {
        return this._http.get<any[]>(this.api.getUrl(`api/Personal/GetPersonalInfoId/${docNum}/${companyId}`));
    }

    getProjectSelectContracts() {
        return this._http.get<any[]>(this.api.getUrl(`api/Project/Select?contracts=true`));
    }

    downloadOrMailReport( filter: string): Observable<Blob> {
      return this._http.get(this.api.getUrl(`api/ReportJava/${filter}`), {responseType: 'blob' });
    }

    getCompaniesSelectWithPayrollTimes(companyId: string): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/Employer/Select?companyInfoId=${companyId}&payrollTimes=true`));
    }

    getPayrollTimesForEmployer(employerInfoId: string): Observable<any> {
        return this._http.get<any[]>(this.api.getUrl(`api/PayrollTime?employerInfoId=${employerInfoId}`));
    }

    getRequirementDocument(employerInfoId: string): Observable<any> {
      return this._http.get<any[]>(this.api.getUrl(`api/Requirement?byCertification=true&byEmployerPersonal&byPersonal`));
    }

}
